export { default as RichTextComponent } from './richTextComponent'
export type { RichTextProps } from './richTextComponent'
